import { Component } from '@angular/core';

@Component({
    selector: 'eup-logout',
    templateUrl: './logout.component.html',
    standalone: false,
})
export class LogoutComponent {}
